/**
 * Small presentational helpers shared by the upload screen and the submission view.
 */

import { ApiError } from './api';

/** A labelled value in the stats grids. */
export function Stat({ label, value }: { label: string; value: string }) {
	return (
		<div className="stat">
			<dt>{label}</dt>
			<dd>{value}</dd>
		</div>
	);
}

/** Pull a human-readable message out of anything thrown by the api layer. */
export function messageOf(error: unknown): string {
	if (error instanceof ApiError) return error.message;
	if (error instanceof Error) return error.message;
	return String(error);
}
